import React from 'react';
import { ThumbsUp, ThumbsDown } from 'phosphor-react';

/**
 * ReactionButtons Component
 * Reusable utility component for card reaction buttons
 * Includes GodGPT, thumbs up, and thumbs down buttons
 */
export const ReactionButtons: React.FC = () => {
  return (
    <div className="flex items-center gap-2 mt-2">
      <button
        className="flex items-center justify-center rounded-full transition-opacity active:opacity-80"
        style={{
          width: '30px',
          height: '30px',
          backgroundColor: '#272727',
        }}
        aria-label="Ask GodGPT"
      >
        <img 
          src="/svg/godgpticon.svg" 
          alt="GodGPT Icon" 
          className="w-4 h-4"
        />
      </button>
      <button
        className="flex items-center justify-center rounded-full transition-opacity active:opacity-80"
        style={{
          width: '30px',
          height: '30px',
          backgroundColor: '#272727',
        }}
        aria-label="Thumbs up"
      >
        <ThumbsUp size={16} weight="regular" className="text-white-pure" />
      </button>
      <button
        className="flex items-center justify-center rounded-full transition-opacity active:opacity-80"
        style={{
          width: '30px',
          height: '30px',
          backgroundColor: '#272727',
        }}
        aria-label="Thumbs down"
      >
        <ThumbsDown size={16} weight="regular" className="text-white-pure" />
      </button>
    </div>
  );
};
